import { styled } from "@linaria/react";
import React from "react";
import Construction from "../Picto/Construction";
import { color, radius } from "..";
import Modal from "../Modal";
import Link from "../Link";
import useModal from "../lib/hooks/useModal";
import { fonts } from "../Theme";
import BlankStateV2 from "../BlankStateV2";

const Pre = styled.span`
  white-space: pre;
`;

const Details = styled.div`
  white-space: pre;
  font-family: monospace;
  text-align: left;
  overflow: auto;
  background-color: ${color.titanium50};
  border-radius: ${radius};
  padding: 16px;
  margin: 16px;
`;

const DetailsLink = styled(Link)`
  color: ${color.lightNitrogen500_Main};
  margin-left: 8px;
  font: ${fonts.body3};
  :hover {
    text-decoration: underline;
  }
`;

interface P {
  error: unknown;
  onError: (error: unknown) => {
    title: string;
    subtitle: string | null;
    cta: string;
    onCTAClick: (() => void) | null;
  };
  resetErrorBoundary: () => void;
}

const ErrorBoundaryFallback = ({ error, onError, resetErrorBoundary }: P) => {
  const { title, subtitle, cta, onCTAClick } = onError(error);
  const [retryDisabled, setRetryDisabled] = React.useState(false);
  const { closeModal, modal, openModal } = useModal();

  const subTitle = (
    <>
      <Pre>{subtitle}</Pre>
      {window.EXPRESS_ENV?.["INTEGRATION"] ? (
        <>
          <br />
          <DetailsLink onClick={openModal}>[details]</DetailsLink>
          <Modal size="full" isOpen={modal} onRequestClose={closeModal} title={title}>
            {error instanceof Error ? (
              <Details>
                {error.stack}
                {error.cause ? (
                  <>
                    <br />
                    <br />
                    Caused by{" "}
                    {error.cause instanceof Error ? error.cause.stack : String(error.cause)}
                  </>
                ) : null}
                {"debugData" in error && error.debugData ? (
                  <>
                    <br />
                    <br />
                    Debug context: {JSON.stringify(error.debugData, null, 2)}
                  </>
                ) : null}
              </Details>
            ) : (
              <Details>{String(error)}</Details>
            )}
          </Modal>
        </>
      ) : null}
    </>
  );

  return (
    <BlankStateV2
      picto={<Construction />}
      title={title}
      subtitle={subTitle}
      onClick={() => {
        setRetryDisabled(true);
        onCTAClick?.();
        resetErrorBoundary();
      }}
      buttonLabel={cta}
      disabled={retryDisabled}
    />
  );
};

export default ErrorBoundaryFallback;
